const IconButton = ({ onClick, children, tooltipText }) => (
  <button
    onClick={onClick}
    title={tooltipText || ""}
    style={{
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      transition: "background 0.3s ease",
    }}
    onMouseOver={(e) => (e.currentTarget.style.background = "#e0e0e0")}
    onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
  >
    {children}
  </button>
);

export default IconButton;
